/**
 * The glyphs "How it's made" needs that the navigation set does not have.
 *
 * Drawn on the same 24-grid with the same 1.6 stroke as `icons.tsx`, so they
 * sit beside it without looking borrowed. Kept here rather than added to that
 * file because these are controls of one canvas, not places in the app.
 */
const PATHS: Readonly<Record<string, string>> = {
  // How a thing comes to exist — the tile drawn where there is no photograph.
  bought: 'M4.5 8.5L12 4.5l7.5 4v8L12 20.5l-7.5-4zM4.5 8.5L12 12.5l7.5-4M12 12.5v8',
  vendor: 'M4 19.5h16M6 19.5V10l4 2.5V10l4 2.5V10l4 2.5v7M8 16h1.5M12 16h1.5M16 16h1.5',
  built: 'M14.5 6.5a3.5 3.5 0 00-4.6 4.6L4.5 16.5l3 3 5.4-5.4a3.5 3.5 0 004.6-4.6l-2.1 2.1-2.4-.6-.6-2.4z',
  consumed: 'M9.5 4.5h5l1 3h-7zM10 7.5v12M14 7.5v12M10 11h4M10 14.5h4M10 18h4',
  robot: 'M9 4h6M12 4v3M6.5 7h11A1.5 1.5 0 0119 8.5v6a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 14.5v-6A1.5 1.5 0 016.5 7zM9.5 10.5v1.5M14.5 10.5v1.5M8 16v2M16 16v2',
  // Canvas controls.
  plus: 'M12 5.5v13M5.5 12h13',
  minus: 'M5.5 12h13',
  fit: 'M4.5 9V4.5H9M15 4.5h4.5V9M19.5 15v4.5H15M9 19.5H4.5V15',
  close: 'M6.5 6.5l11 11M17.5 6.5l-11 11',
  chevronRight: 'M10 6.5l5.5 5.5-5.5 5.5',
  chevronDown: 'M6.5 10l5.5 5.5 5.5-5.5',
  diagram: 'M4 9.5h5v5H4zM15 4.5h5v5h-5zM15 14.5h5v5h-5zM9 12h3M12 7h3M12 17h3M12 7v10',
  outline: 'M4.5 6h15M8.5 12h11M8.5 18h11M4.5 12v6',
  open: 'M13.5 4.5h6v6M19.5 4.5l-8 8M17.5 13.5v5a1 1 0 01-1 1h-11a1 1 0 01-1-1v-11a1 1 0 011-1h5',
  edit: 'M14.5 5.5l4 4L9 19H5v-4zM12.5 7.5l4 4',
  focus: 'M12 15a3 3 0 100-6 3 3 0 000 6zM12 3.5v3M12 17.5v3M3.5 12h3M17.5 12h3',
  expand: 'M7 9.5l5-5 5 5M7 14.5l5 5 5-5',
  collapse: 'M7 4.5l5 5 5-5M7 19.5l5-5 5 5',
}

export function TreeIcon({ name, size = 16 }: { name: string; size?: number }): JSX.Element {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name] ?? 'M12 12v.01'} />
    </svg>
  )
}
